import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Table } from 'shared/table';
import { formatCurrency } from 'shared/utils';
import { Container } from './MassFundsDistributionList.styles';

export const MassFundsDistributionList = (props: {
  centrosCosto: any[];
}) => {
  const { unregister, register, getValues } = useFormContext();

  const [renderSelected, setRenderSelected] = useState(false);

  const selectRow = (row: any, id: string) => {
    // Si no está setteado el valor, lo registramos, sino, lo eliminamos
    if (!getValues(id)) {
      register(id, {
        value: row.id,
      });
    } else {
      unregister(id);
    }
    setRenderSelected(true);
  };

  useEffect(() => {
    // Forzamos a la renderización de los elementos seleccionados
    if (renderSelected) {
      setRenderSelected((m) => !m);
    }
  }, [renderSelected, setRenderSelected]);

  return (
    <Container>
      <Table
        thead={
          <tr>
            <th colSpan={2}>Nombre</th>
            <th>Saldo disponible</th>
          </tr>
        }
        tbody={
          <>
            {!!props.centrosCosto && props.centrosCosto.length > 0 ? (
              <>
                {props.centrosCosto.map((row, i) => (
                  <tr
                    className={`selectable-row ${getValues('children' + i) ? 'selected' : ''}`}
                    key={'children' + i}
                    data-testid={'children-test-' + i}
                    onClick={() => selectRow(row, 'children' + i)}
                  >
                    <td colSpan={2} className="align-middle">
                      {row.formattedName}
                    </td>
                    <td className="align-middle">
                      {formatCurrency(row.disponible.disponible)}
                    </td>
                  </tr>
                ))}
              </>
            ) : (
              <>
                <tr key="empty">
                  <td colSpan={3}>
                    El padre seleccionado no tiene hijos a los que transferir
                  </td>
                </tr>
              </>
            )}
          </>
        }
      />
    </Container>
  );
};
